<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">客户故事</span></p>
      </div>
      <div class="main row justify-content-between">
        <div class="col-md-8 col-11">
          <Detail1 v-show="id == '1'"></Detail1>
          <Detail2 v-show="id == '2'"></Detail2>
          <Detail3 v-show="id == '3'"></Detail3>
          <Detail4 v-show="id == '4'"></Detail4>
          <Detail5 v-show="id == '5'"></Detail5>
          <Detail6 v-show="id == '6'"></Detail6>
        </div>

        <div class="col-md-3 text-left asideList">
          <p class="subtitle">热门文章</p>
          <a href="javascript:void(0)" @click="toLink(1)"><p class="link-block" v-bind:class="{active: id == 1}"><span>骨子里就喜欢折腾的上海女人</span></p></a>
          <a href="javascript:void(0)" @click="toLink(2)"><p class="link-block" v-bind:class="{active: id == 2}"><span>19年，从设计师到老板，在中国做设计越来越有尊严</span></p></a>
          <a href="javascript:void(0)" @click="toLink(3)"><p class="link-block" v-bind:class="{active: id == 3}"><span>种梨13年，河北农民老梁的“鸭梨”</span></p></a>
          <a href="javascript:void(0)" @click="toLink(4)"><p class="link-block" v-bind:class="{active: id == 4}"><span>浙江农村小伙，白手起家的酒店梦</span></p></a>
          <a href="javascript:void(0)" @click="toLink(5)"><p class="link-block" v-bind:class="{active: id == 5}"><span>我做时尚教育，就是想让中国有自己的服装品牌</span></p></a>
          <a href="javascript:void(0)" @click="toLink(6)"><p class="link-block" v-bind:class="{active: id == 6}"><span>从传统差事到连锁创新，80后超市创二代的生意经！</span></p></a>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Header from './Header'
  import Footer from './Footer'
  import Detail1 from './Detail1'
  import Detail2 from './Detail2'
  import Detail3 from './Detail3'
  import Detail4 from './Detail4'
  import Detail5 from './Detail5'
  import Detail6 from './Detail6'


  export default {
    name: "CustomerDetail",
    components:{Header,Footer,Detail1,Detail2,Detail3,Detail4,Detail5,Detail6},
    data(){
      return {
        id:''
      }
    },
    created() {
      let u = window.location.href.split('?')[1].substr(3,1);
      this.id = u;
    },
    mounted() {
      $('html,body').animate({
          scrollTop: 0
        },
        10);
    },
    methods: {
      toLink: function(id) {
        this.id = id;
        window.location.href = '/#/CustomerDetail?id=' + id;
        $('html,body').animate({
            scrollTop: 0
          },
          350);
      }
    }
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  a:hover{text-decoration: none;}

  //pc、laptop
  @media screen and (min-width: 769px) {
    .top,.main{
      width:1300px !important;
    }
    .desc {
      font-size: 14px;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
    }
    .asideList{
      display: none;
    }
    .top{
      font-size: 26px;
    }
    .desc {
      font-size: 26px;
    }
  }

  .top{
    margin: 60px auto 48px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }
  }
  .main{
    margin:0 auto;
    padding-left:50px;
    padding-bottom:190px;

    //左边
    .title{font-size:36px;font-weight:bold;}
    .desc{
      font-size:14px;
      margin-bottom:50px;
      line-height: 42px;

      .author{
        color:#006D73;
      }
    }
    .main-content{
      .normal,.bold{
        margin-bottom:30px;
      }
      .bold{
        font-size:22px;
        font-weight:bold;
        /*height:16px;*/
        span{
          /*background:linear-gradient(to bottom, transparent 0%, rgba(0,109,115,0.2) 50%, rgba(0,109,115,0.2) 100%);*/
        }

      }
    }

    //右边
    .subtitle{
      font-size: 20px;
      color: #787B80;
      margin-bottom:29px;
    }
    .link-block{
      width:100%;
      height:80px;
      border-bottom:1px solid #eee;
      padding:0 17px;
      display: table;
      color:#35383D;
      /*font-weight:bold;*/

      span{
        display: table-cell;
        vertical-align: middle;
      }

      &.active{
        background:#008B7D;
        color:#fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomerDetail.vue